module.exports = __webpack_public_path__ + "img/bg-login.fcd9e975.png";